// React
import React, { useState } from 'react';

// Store
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';

// Components
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import ADGMPagination from 'aurora-components/ADGMPagination';
import Hidden from '@material-ui/core/Hidden';

// Utils
import { keyEmptyCheck } from 'aurora-utils/utils';
import ceil from 'lodash/ceil';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import ADGMPanel from 'aurora-components/ADGMPanel';
import { CleverTapPMARemovePropertyEvent } from 'aurora-utils/cleverTap.eventhelper';
import { removePMAProperties, getPMAUnits } from 'aurora-composition/modules/pma/actions';
import history from 'aurora-utils/history';

// Images
import AddIcon from 'aurora-images/plusIconBlack.svg';

import BuildingDisplay from './BuildingDisplay.js';
import RemovePropertyModal from './RemovePropertyModal';

// Styles
import styles from './styles';

function SelectedPropertiesList(props) {
  const {
    classes,
    applicationId,
    page,
    setPage,
    properties,
    setFetchProperties,
    isRenewal,
    isAmendment,
    activeStepName,
    application,
  } = props;

  const [building, setBuilding] = useState(null);

  const { lang } = useSelector(
    createSelector(
      state => state.language,
      language => ({
        lang: language.locale,
      }),
    ),
  );

  const dispatch = useDispatch();

  const addPropertyRoute = () => {
    history.push(
      '/app/services/pma-select-properties/?id=' +
        applicationId +
        '&propertyType=2' +
        (isRenewal
          ? '&isRenewal=true'
          : isAmendment
          ? '&isAmendment=true&callSecondApi=' + application?.callSecondApi
          : '&isRegistration=true'),
    );
  };

  const getUnitsToRemove = selectedBuilding => {
    CleverTapPMARemovePropertyEvent({
      screenName: `screen_${application?.applicationDetails?.applicationType || ''}_${activeStepName}_view`,
      applicationStatus: application?.applicationDetails?.applicationStatus || '',
      applicationId: applicationId || null,
      applicationNumber: application?.applicationNumber?.applicationNumber || null,
      applicationType: application?.applicationDetails?.applicationType || '',
      stepName: activeStepName,
    });
    dispatch(getPMAUnits({ applicationId, buildingRegNumber: selectedBuilding.buildingRegNumber })).then(res => {
      if (!res?.success) return;
      res?.result?.properties &&
        dispatch(
          removePMAProperties({
            applicationId: +applicationId,
            plotIds: res?.result?.properties?.map(plot => plot.plotId),
          }),
        ).then(() => {
          setFetchProperties(true);
        });
    });
  };

  const doesPropertiesExists = !isEmpty(properties?.properties);

  return (
    <>
      {building?.buildingRegNumber && (
        <RemovePropertyModal
          onClose={() => setBuilding(null)}
          open={building?.buildingRegNumber}
          removeProperty={() => getUnitsToRemove(building)}
          unitRegNum={building?.buildingRegNumber}
          buildingCount={building?.count}
        />
      )}

      <ADGMPanel
        title={keyEmptyCheck(doesPropertiesExists ? 'property_details' : 'select_property')}
        classes={{
          title: classes.modifiedTitle,
          titleHead: classes.modifiedTitleWrapper,
        }}
        extraHeaderComponents={
          doesPropertiesExists &&
          !isRenewal && (
            <Button
              variant='outlined'
              className={classNames(classes.addPropertyHeadingBtn)}
              size='large'
              onClick={addPropertyRoute}
            >
              <Hidden mdDown>
                <img src={AddIcon} alt='add-icon' width='15px' height='15px' />
              </Hidden>
              {keyEmptyCheck('add_property')}
            </Button>
          )
        }
      >
        <>
          <div className={classNames(classes.innerCardGrid, classes.occupantsinnerCardGrid)}>
            {!doesPropertiesExists && !isRenewal && (
              <div className={classes.addBrokerbtnHolder}>
                <Button
                  variant='outlined'
                  className={classNames(classes.btns, classes.addBrokersBtn)}
                  size='large'
                  onClick={addPropertyRoute}
                >
                  <img src={AddIcon} alt='add-icon' width='15px' height='15px' />
                  {keyEmptyCheck('add_property')}
                </Button>
              </div>
            )}
            {doesPropertiesExists &&
              properties?.properties.map(buildingDetails => (
                <BuildingDisplay
                  building={buildingDetails}
                  applicationId={applicationId}
                  confirmDelete={() => setBuilding(buildingDetails)}
                  locale={lang}
                />
              ))}
          </div>
        </>
      </ADGMPanel>
      {doesPropertiesExists && (
        <div className={classes.paginationHolder}>
          <ADGMPagination
            totalPages={ceil(properties?.totalCount / 5)}
            currentPage={Number(page)}
            onPageChange={num => setPage(num)}
            customClasses={{ root: classes.pagination }}
          />
        </div>
      )}
    </>
  );
}

SelectedPropertiesList.propTypes = {
  classes: PropTypes.object.isRequired,
  applicationId: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  setPage: PropTypes.func.isRequired,
  properties: PropTypes.array.isRequired,
  setFetchProperties: PropTypes.func.isRequired,
  isRenewal: PropTypes.bool.isRequired,
  isAmendment: PropTypes.bool.isRequired,
  activeStepName: PropTypes.string.isRequired,
  application: PropTypes.object.isRequired,
};
export default withStyles(styles)(SelectedPropertiesList);
